import React, { Fragment } from 'react';
import {Segment, Button, Icon, Table, Checkbox, Header, Popup, Loader, Grid} from 'semantic-ui-react';
import axios from 'axios';
import { FiltersOnStyle, HeaderCursor, IconHeader } from '../../../../Professor/ProfessorInputGrades/css';
import { Link, Redirect } from 'react-router-dom';
import CreateCandidates from '../CreateCandidates/CreateCandidates';
import CreateCandidatesFromUNSA from '../CreateCandidates/CreateCandidatesFromUNSA';
import request from '../../Util/request';
import { toast, ToastContainer } from 'react-toastify';
import SearchTableData from "../../../../util/SearchTableData";
import PaginationFront from "../../../../util/PaginationFront";


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const NoDataMessage = () => <p>Nema povezanih kandidata.</p>;

export default class ConnectedCandidatesPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            candidates: [],
            showCreateCandidate: false,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
        };

        this.closeForm = this.closeForm.bind(this);
        this.getAllCandidates = this.getAllCandidates.bind(this);
        this.onDeleteCandidate = this.onDeleteCandidate.bind(this);

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.candidates;
    }

    getResults(results) {
        this.setState({ results, activePage: 1 });
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    closeForm() {
        this.setState({
            showCreateCandidates: false
        });
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
        this.getAllCandidates();
    }

    onDeleteCandidate(candidateId) {
        this.setState({ currentCandidateId: candidateId, deleting: true });
        axios.delete(`equivalence/delete-candidate/${candidateId}/`).then(response => {
            this.getAllCandidates();
            this.setState({ currentCandidateId: null, deleting: false });
            toast('Uspješno ste izbrisali kandidata.');
        }).catch(err => {
            this.setState({ loader: false, deleting: false });

            if (err.response.data === 'This candidate has courses.') {
                toast('Nije moguće obrisati kandidata koji ima predmete.');
            } else {
                toast('Došlo je do greške, kandidat nije izbrisan!');
            }
        });
    }

    getAllCandidates() {
        axios.get('/equivalence/current-year-processed').then(response => {
            this.setState({ loader: true });
            this.setState({
                loader: false,
                candidates: response.data.map(el => ({
                    firstName: el.firstName,
                    lastName: el.lastName,
                    sourceStudyProgram: el.sourceStudyProgram,
                    targetStudyProgramName: el.targetStudyProgramName,
                    targetStudyProgramBasicName: el.targetStudyProgramBasicName,
                    candidateId: el.candidateId,
                    status: el.status,
                    committeeDisplayName: el.committeeAcademicYear + ' ' + el.committeeType,
                    sourceUniversity: el.sourceUniversity,
                    sourceOrganizationalUnit: el.sourceOrganizationalUnit,
                    sourceDepartment: el.sourceDepartment,
                }))
            });
        }).catch(err => {
            this.setState({ loader: false });
            toast('Nije moguće dobaviti kandidate!');
        });
    }

    render() {

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.state.showCandidateInfo === true) {
            return <Redirect push to={{ pathname: '/ekvivalencija-ispita/prikaz-kandidata/detalji', state: { student: 1 } }} />;
        }

        return (
            <div>


                {this.state.showCreateCandidate && <CreateCandidates getAllCandidates={this.getAllCandidates} closeForm={this.closeForm} />}
                {this.state.showCreateCandidateFromUNSA && <CreateCandidatesFromUNSA getAllCandidates={this.getAllCandidates} closeForm={this.closeForm} />}

                { this.state.loader ?
                    <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    <Fragment>
                        {currentPosts.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={17} >
                                            <Grid stackable>
                                                <Grid.Column width={17}>
                                                    <SearchTableData profMozilla data={this.state.candidates} getResults={this.getResults} filterItem={['firstName', 'lastName', 'sourceUniversity', 'sourceDepartment', 'sourceStudyProgram', 'targetStudyProgramName', 'targetStudyProgramBasicName', 'committeeDisplayName']} />
                                                </Grid.Column>
                                            </Grid>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>Prezime i ime</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Univerzitet
                                                    <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Fakultet
                                                    <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}><Header as="h4" image>
                                            <Header.Content>
                                                Odsjek
                                                <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                            </Header.Content></Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}><Header as="h4" image>
                                            <Header.Content>
                                                Studijski program
                                                <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                            </Header.Content></Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}><Header as="h4" image>
                                            <Header.Content>
                                                Studijski program
                                                <Header.Subheader>na koji prelazi</Header.Subheader>
                                            </Header.Content></Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>Komisija</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={1}>Status</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={1}></Table.HeaderCell>

                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {currentPosts.map((el, index) =>
                                        (<Table.Row
                                            key={index}
                                            // style={HeaderCursor}
                                        >
                                            <Table.Cell verticalAlign="middle" width={1}>
                                                {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.lastName} {el.firstName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.sourceUniversity}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.sourceOrganizationalUnit}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.sourceDepartment}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.sourceStudyProgram}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.targetStudyProgramName + ' | ' + el.targetStudyProgramBasicName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.committeeDisplayName}
                                            </Table.Cell>
                                            <Table.Cell colSpan={1} verticalAlign="middle" positive={el.status === 'MERGED'} negative={!(el.status === 'MERGED')}>
                                                {el.status === 'MERGED' ? <div style={{ float: 'right' }}><Icon name="checkmark" /></div> : <div style={{ float: 'right' }}><Icon name="close" /></div>}
                                                {el.status === 'MERGED' ? 'upisan' : 'odustao'}

                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan={1}>
                                                <Popup
                                                    content="Detalji"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            // disabled={this.state.edit}
                                                            compact
                                                            basic="true"
                                                            circular
                                                            icon="align justify"
                                                            size="small"
                                                            color="blue"
                                                            onClick={() => {
                                                                localStorage.setItem('candidateId', el.candidateId);
                                                                localStorage.setItem('candidateEquivalenceStatus', el.status);
                                                                localStorage.setItem('candidateFirstName', el.firstName);
                                                                localStorage.setItem('candidateLastName', el.lastName);
                                                                localStorage.setItem('showAddButton', 'yes');
                                                                this.setState({ showCandidateInfo: true });
                                                            }}
                                                        />}
                                                />
                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={this.state.deleting && this.state.currentCandidateId !== el.candidateId}
                                                            compact
                                                            basic="true"
                                                            circular
                                                            icon="trash alternate"
                                                            size="small"
                                                            color="red"
                                                            onClick={() => this.onDeleteCandidate(el.candidateId)}
                                                        />}
                                                />
                                            </Table.Cell>
                                        </Table.Row>))}
                                </Table.Body>

                            </Table>


                            : <NoDataMessage />
                        }
                        {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </Fragment>}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesTab/ConnectedCandidatesPreview.js